import styled from "styled-components"

import Shadow from "../../images/sombra@2x.png"

export const Hero = styled.div`
  height: 518px;
  position: relative;

  &:after {
    content: "";
    width: 100%;
    height: 100px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center -90px;
    background-image: url(${Shadow});
  }

  @media screen and (min-width: 768px) {
    height: 80vh;
  }
`

export const HeroBoxVideo = styled.div`
  overflow: hidden;
  height: 100%;

  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 70, 96, 0.8) 0%,
      rgba(0, 70, 96, 0.65) 30%,
      rgba(0, 70, 96, 0.28) 60%,
      rgba(0, 70, 96, 0) 100%
    );
    content: "";
    z-index: 1;
  }
`

export const HeroVideo = styled.video`
  height: 100%;
  object-fit: cover;
  width: 100%;
  min-height: 100%;
  height: auto;
`

export const HeroOverlay = styled.div`
  background: rgb(34, 193, 195, 0.7);
  background: linear-gradient(
    205deg,
    rgba(34, 193, 195, 0.7) 60%,
    rgba(253, 187, 45, 0.6) 100%
  );
  position: absolute;
  width: 100%;
  height: 100%;
`

export const HeroContent = styled.div`
  font-family: "Montserrat", sans-serif;
  position: absolute;
  z-index: 9;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  font-weight: 100;
`

export const HeroTitle = styled.h1`
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: 100;
  line-height: 30px;
  text-shadow: 0 1px 3px rgba(9, 100, 100, 0.8);

  @media screen and (min-width: 768px) {
    font-size: 40px;
    font-size: 40px;
    line-height: 50px;
  }
`

export const HeroDescription = styled.h2`
  font-size: 18px;
  margin-bottom: 40px;
  font-weight: 100;
  line-height: 25px;
  text-shadow: 0 1px 3px rgba(9, 100, 100, 0.8);

  @media screen and (min-width: 768px) {
    font-size: 30px;
    margin-bottom: 50px;
    line-height: 40px;
  }
`

export const HeroCta = styled.a`
  font-family: "Open Sans", sans-serif;
  color: rgba(0, 198, 199, 1);
  border: none;
  background-color: #fff;
  padding: 16px 30px;
  border-radius: 3px;
  font-weight: bold;
  white-space: nowrap;
  font-size: 14px;
  outline: none;
  text-decoration: none;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    font-size: 20px;
    padding: 20px 40px;
  }
`
